import { BACKEND_PUBLIC } from '../base'

export async function getList(limit = 10, offset = 0) {
  return BACKEND_PUBLIC.get<LX.Paginated<{ blog: LX.Post[] }>>('/blog/list', { params: { limit, offset } })
}

export async function getPost(url: string) {
  return BACKEND_PUBLIC.get<LX.Post>('/blog/get', { params: { url } })
}
